import { FindInPageOutlined } from '@mui/icons-material';
import { Box, ListItemIcon, Stack, Typography } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { ExtendedListItem, ExtendedListItemText } from '@procureai/ui-mui';

import { DemandRecommendationFormPropsType } from '../DemandRecommendationForm/DemandRecommendationForm.types';
import { SelectionButton } from '../SelectionButton/SelectionButton';
import { TsrctRecommendationDecisionStatus } from '@/generated/gql/graphql';

import { RecommendationItemContentStyled } from './RecommendationItemContent.styled';

interface RecommendationItemContentProps extends Omit<DemandRecommendationFormPropsType, 'ref'> {
  title: string;
  description: string;
  isActive: boolean;
  links?: React.ReactNode;
}

export const RecommendationItemContent = ({
  value,
  title,
  description,
  isActive,
  onChange,
  links,
}: RecommendationItemContentProps) => {
  const isAccepted = value?.decisionStatus === TsrctRecommendationDecisionStatus.ACCEPTED ? true : false;
  return (
    <ExtendedListItem disableGutters sx={{ p: 0 }}>
      <RecommendationItemContentStyled isAccepted={isAccepted}>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <ListItemIcon sx={{ justifyContent: 'flex-end' }}>
            <FindInPageOutlined color={isAccepted ? 'success' : undefined} />
          </ListItemIcon>
          <Stack
            spacing={2}
            sx={{
              padding: 2,
              width: '100%',
            }}
          >
            <Stack
              direction="row"
              spacing={2}
              sx={{
                alignItems: 'flex-end',
                padding: 2,
              }}
            >
              <ExtendedListItemText
                primary={<Typography variant="subtitle1">{title}</Typography>}
                secondary={
                  <>
                    <Typography component="span" variant="body2">
                      {description}
                    </Typography>
                    <Stack component="span">{links}</Stack>
                  </>
                }
              />
              {isActive && value && (
                <Stack>
                  <Box
                    sx={{
                      flex: 1,
                    }}
                  />
                  <Restricted needs={{ permission: Permission.DemandRecommendationApply }}>
                    <SelectionButton value={value} onChange={onChange} />
                  </Restricted>
                </Stack>
              )}
            </Stack>
          </Stack>
        </Stack>
      </RecommendationItemContentStyled>
    </ExtendedListItem>
  );
};
